<app-base-template (modal)="openModal(content)" (searchmodal)="searchModal()" (tabledata)="getTableData()"
    [displayData]="displayData" [nextOffset]="nextOffset" [previousOffset]="previousOffset" (offset)="getData($event)"
    (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showSearch]="showSearch"
    [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Configuration</div>

    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected"
                (change)="clientIdSpecific($event)">
                <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="fieldSelected"
                (change)="onFieldChange($event.target.selectedIndex)">
                <option *ngFor="let field of fields" [value]="field.id">{{field.name}}</option>
            </select>
        </div>
        <!--<div class="form-group">-->
        <!--<label for="file">Choose File</label>-->
        <!--<input type="file"-->
        <!--id="file"-->
        <!--(change)="handleFileInput($event.target.files)">-->
        <!--</div>-->
        <div class="form-group" [hidden]="!hiddenRadio">
            <mat-radio-group aria-label="Select an option">
                <mat-radio-button value="1" (change)="adddescription()">Create New</mat-radio-button> &nbsp;&nbsp;
                <mat-radio-button value="2" (change)="changedescription()">Add Existing</mat-radio-button>
            </mat-radio-group>
            <!--<div class=" rowmar-lft-rgt-0">-->
            <!--<div class="col-sm-6 pad-15 text-center">-->
            <!--<app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName" [formData]="formdata"-->
            <!--[maxFile]="MAX_FILE_UPLOAD"-->
            <!--(uploadError)="onFileError($event)"-->
            <!--(complete)="onFileComplete($event)" (dataLoaded)="onUpload($event)"></app-material-fileupload>-->
            <!--</div>-->
            <!--<div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}}-->
            <!--</div>-->
            <!--</div>-->
        </div>
        <div class="form-group" [hidden]="!hiddencolor">
            <mat-radio-group aria-label="Select an option">
                <mat-radio-button value="1" (change)="addColorPicker()">Add Color</mat-radio-button> &nbsp;&nbsp;
                <mat-radio-button value="2" (change)="addImage()">Add Image</mat-radio-button>
            </mat-radio-group>
        </div>


        <div class="form-group" [hidden]="fieldloader">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectField"
                (change)="valueFunc($event.target.selectedIndex)">
                <option *ngFor="let fieldValue of fieldValues" [value]="fieldValue.id">{{fieldValue.name}}
                </option>
            </select>
            <br>
            <br>
            <div class="form-group">
                <input type="text" class="form-control radius-0 font-13" [(ngModel)]="editValue">
            </div>
            <div class="form-group" [hidden]="!colorpicker">
                <input class="form-control radius-0 font-13" [(colorPicker)]="color" placeholder="Color Picker"
                    [style.background]="color" />
            </div>
            <div class="form-group">
                <input class="form-control radius-0 font-13" placeholder="Enter Sequence Number"
                    [(ngModel)]="sequenceNumber">
            </div>
            <div class="form-group mar-bot-0 font-13" [hidden]="!hiddenRadio1">
                <label id="label1">Management View</label>
                <br>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="managementValue">
                    <mat-radio-button value="1">My Workspace</mat-radio-button> &nbsp;&nbsp;
                    <mat-radio-button value="2">Team Workspace</mat-radio-button>
                </mat-radio-group>
            </div>
            <!--<div class="form-group" [hidden]="!management">-->
            <!--<input class="form-control radius-0 font-13" placeholder="Management View" [(ngModel)]="managementValue">-->
            <!--</div>-->

            <div class="row mar-lft-rgt-0" [hidden]="!file">
                <label id="label1" class="font-13">Attach Image </label>
                <br>

                <div class="col-sm-6 mar-lft-rgt-0 text-center">
                    <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName" [formData]="formdata"
                        [maxFile]="MAX_FILE_UPLOAD" (uploadError)="onFileError($event)"
                        (complete)="onFileComplete($event)" (dataLoaded)="onUpload($event)"></app-material-fileupload>
                </div>
                <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}}
                </div>
            </div>
            <div class="pad-8 modal-footer">
                <button type="button" class="btn btn-success radius-0" (click)="submitUpdate()">Submit</button>
                <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
            </div>

        </div>
        <div [hidden]="addloader">
            <div class="form-group">
                <input type="text" class="form-control radius-0 font-13" placeholder="Add description"
                    [(ngModel)]="newDescription">
            </div>
            <div class="form-group" [hidden]="!colorpicker">
                <input class="form-control radius-0 font-13" [(colorPicker)]="color" placeholder="Color Picker"
                    [style.background]="color" />
            </div>
            <div class="form-group">
                <input class="form-control radius-0 font-13" placeholder="Enter Sequence Number"
                    [(ngModel)]="sequenceNumber">
            </div>
            <!--<div class="form-group" [hidden]="!management">-->
            <!--<input class="form-control radius-0 font-13" placeholder="Management View" [(ngModel)]="managementValue">-->
            <!--</div>-->

            <div class="form-group mar-bot-0 font-13" [hidden]="!hiddenRadio1">
                <label id="label1">Management View</label>
                <br>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="managementValue">
                    <mat-radio-button value="1">My Workspace</mat-radio-button> &nbsp;&nbsp;
                    <mat-radio-button value="2">Team Workspace</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="row mar-lft-rgt-0" [hidden]="!file">
                <label id="label1" class="font-13">Attach Image </label>
                <br>

                <div class="col-sm-6 mar-lft-rgt-0 text-center">
                    <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName" [formData]="formdata"
                        [maxFile]="MAX_FILE_UPLOAD" (uploadError)="onFileError($event)"
                        (complete)="onFileComplete($event)" (dataLoaded)="onUpload($event)"></app-material-fileupload>
                </div>
                <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}}
                </div>
            </div>
            <div class="pad-8 modal-footer">
                <button type="button" class="btn btn-success radius-0" (click)="save()">Submit</button>
                <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #content1 let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title"> Update Configuration</div>

    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" placeholder="Add description"
                [(ngModel)]="newDescription">
        </div>

        <div class="form-group" [hidden]="!colorpicker">
            <input class="form-control radius-0 font-13" [(colorPicker)]="color" placeholder="Color Picker"
                [style.background]="color" />
        </div>
        <div class="form-group">
            <input class="form-control radius-0 font-13" placeholder="Enter Sequence Number"
                [(ngModel)]="sequenceNumber">
        </div>
        <div class="form-group mar-bot-0 font-13" [hidden]="!hiddenRadio1">
            <label id="label1">Management View</label>
            <br>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="managementValue">
                <mat-radio-button value="1">My Workspace</mat-radio-button> &nbsp;&nbsp;
                <mat-radio-button value="2">Team Workspace</mat-radio-button>
            </mat-radio-group>
        </div>
        <!--<div class="form-group" [hidden]="!management">-->
        <!--<input class="form-control radius-0 font-13" placeholder="Management View" [(ngModel)]="managementValue">-->
        <!--</div>-->

        <div class="form-group" [hidden]="!file">
            <img src="{{imgUrl}}" class="form-control radius-0 font-13 logo">
        </div>

        <div class="row mar-lft-rgt-0" [hidden]="!file">
            <label id="label1" class="font-13">Attach Image </label>
            <br>

            <div class="col-sm-6 mar-lft-rgt-0 text-center">
                <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName" [formData]="formdata"
                    [maxFile]="MAX_FILE_UPLOAD" (uploadError)="onFileError($event)" (complete)="onFileComplete($event)"
                    (dataLoaded)="onUpload($event)"></app-material-fileupload>
            </div>
            <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}}
            </div>
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="update()">Update</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Search</div>
    </div>
    <div class="modal-body">
        <div class="form-group mar_top">
            <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Function Description "
                [(ngModel)]="funSelected">
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>

        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>
<notifier-container></notifier-container>